<template>
    <v-card class="providers-component">
        <v-card-title>
            <h2 class="icon-title mb-0" style="width: 100%; align-items: center">
                <span>
                    <v-icon class="mr-2" color="primary">${{ type.icon }}</v-icon>{{ $t(type.name) }}
                </span>
                <span>
                    <v-menu offset-y left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click.stop="" depressed class="bg-gradient">
                                <v-icon left dark small>$plus_l</v-icon><b style="text-transform : none !important;">{{ $t('add') }}</b>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(provider_list, index) in providers_list" :key="index" link dense @click="getForm(providerEditUrl.replace('{{id}}', provider_list.id))">
                                <v-list-item-title>{{ provider_list.name }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </span>
            </h2>
        </v-card-title>

        <v-card-text class="pb-2">
            <v-list v-if="providers.length" class="pt-0">
                <v-list-item v-for="provider in providers" :key="provider.id" class="item mb-2">
                    <v-list-item-avatar :color="provider.provider_id.logo ? '' : 'lightgrey'" tile size="50">
                        <img v-if="provider.provider_id.logo" :src="provider.provider_id.logo">
                        <v-icon v-else small>$user_s</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title v-text="provider.name"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-icon>
                        <v-btn depressed text color="primary" class="square" @click="openForm('edit', providerEditUrl.replace('{{id}}', provider.provider_id.id ? provider.provider_id.id : provider.provider_id) + provider.id)">
                            <v-icon dark small> $pencil_d </v-icon>
                        </v-btn>

                        <v-btn depressed text color="primary" class="square" @click="openForm('edit', providerDeleteUrl.replace('{{id}}', provider.id))">
                            <v-icon dark small> $trash_d </v-icon>
                        </v-btn>
                    </v-list-item-icon>
                </v-list-item>
            </v-list>

            <div v-else>
                <v-alert border="left" color="info" text>
                    {{ $t("emptyArrayInfoMessage") }}
                </v-alert>
            </div>
        </v-card-text>

        <FormDialogComponent v-if="form" ref="componentForm" :form="form" :action="'SET_DATA'" />
    </v-card>
</template>

<script>
import GenericDataService from '@/services/GenericDataService';
import FormDialogComponent from "@/components/dialogs/FormDialogComponent";
import getForm from "@/mixins/mixins";

export default {
    name: "providersComponent",
    props: ["type"],
    mixins: [getForm],
    components:{ FormDialogComponent },
    data() {
        return {
            providers: [],
            providers_list: [],
            form: null,
            providerEditUrl: "provider_list/{{id}}/getProviderForm?provider_id=",
            providerDeleteUrl: "provider/{{id}}/checkBeforeDelete",
        };
    },
    mounted() {
        this.loadProviders();
        this.loadProvidersList();
    },
    methods: {
        openForm(formType, formUrl) {
            this.formType = formType;
            this.formUrl = formUrl;
            this.getForm(formUrl);
        },
        loadProviders() {
            GenericDataService.getData('provider/getProviders?type=' + this.type.type).then((response) => {
                this.providers = response.data.data;
            });
        },
        loadProvidersList() {
            GenericDataService.getData('provider_list/getProvidersListByType?type=' + this.type.type).then((response) => {
                this.providers_list = response.data.data;
            });
        },
        customRefresh() {
            this.loadProviders();
        }
    }
};
</script>

<style lang="scss">
    .providers-component {
        .item {
            border: 1px solid lightgrey;
            border-radius: 4px;
        }
    }
</style>